import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { initializeApp } from 'firebase/app';
import { MainView } from './mainView';
import { servicesColors } from './theme';
// Firebase config
const firebaseConfig = {
    apiKey: 'AIzaSyDH2gjVPnP0K5oPkKgbekHAYZwP1L7dC_c',
    authDomain: 'stanorai-outreach.firebaseapp.com',
    projectId: 'stanorai-outreach',
    storageBucket: 'stanorai-outreach.firebasestorage.app',
    messagingSenderId: '380863858498',
    appId: '1:380863858498:web:2db9e9f75a67b00b8e8f9c'
};
initializeApp(firebaseConfig);
// Custom theme for Local Services
const theme = createTheme({
    palette: {
        primary: {
            main: servicesColors.primary,
            light: servicesColors.primaryLight,
            dark: servicesColors.primaryDark,
        },
        secondary: {
            main: servicesColors.secondary,
            light: servicesColors.secondaryLight,
            dark: servicesColors.accentDark,
        },
        success: {
            main: servicesColors.success,
        },
        background: {
            default: servicesColors.background,
        },
    },
    typography: {
        fontFamily: '"Rubik", "Roboto", "Helvetica", "Arial", sans-serif',
        h1: { fontWeight: 800, letterSpacing: '-0.02em' },
        h2: { fontWeight: 700, letterSpacing: '-0.01em' },
        h3: { fontWeight: 700 },
        h4: { fontWeight: 600 },
        button: { textTransform: 'none', fontWeight: 600 },
    },
    shape: {
        borderRadius: 12,
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    padding: '12px 28px',
                },
                containedPrimary: {
                    background: servicesColors.gradient,
                    boxShadow: '0 4px 14px rgba(30, 58, 95, 0.25)',
                    '&:hover': {
                        boxShadow: '0 6px 20px rgba(30, 58, 95, 0.35)',
                    },
                },
                containedSecondary: {
                    backgroundColor: servicesColors.secondary,
                    boxShadow: '0 4px 14px rgba(199, 146, 62, 0.3)',
                    '&:hover': {
                        backgroundColor: servicesColors.accentDark,
                    },
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                },
            },
        },
    },
});
const container = document.getElementById('root');
if (container) {
    const root = createRoot(container);
    root.render(_jsxs(ThemeProvider, { theme: theme, children: [_jsx(CssBaseline, {}), _jsx(MainView, {})] }));
}
